import styled from "styled-components";
import {
	TABLET_M_BP,
	MOBILE_L_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
export const CurriculumWrapper = styled.div`
	padding: 80px 0;
	.request-syllabus-btn-wrapper {
		width: 294px;
	}
	.request-syllabus-btn-wrapper > button {
		width: 100%;
	}
	.flex-column {
		display: flex;
		flex-direction: column;
	}
	.gap1 {
		gap: 1rem;
	}
	.gap05 {
		gap: 0.5rem;
	}
	.gap15 {
		gap: 1.5rem;
	}
	.overlay-wrapper {
		${(props) =>
			props.topicsCount > 7 &&
			`::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background-color: transparent;
      border: none;
    }

    ::-webkit-scrollbar-thumb {
      background: #e6e6e6;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #d9d7d7;
    }`}

		height: 17.5rem;
		overflow-y: scroll;
	}
	.header-cta {
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
		justify-content: end;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 40px 0;
		.curriculum-tab-topics {
			gap: 0.5rem;
		}
		.topic-header-content {
			gap: 1rem;
		}
		.header-title-wrapper,
		.header-cta {
			align-items: center;
			text-align: center;
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.request-syllabus-btn-wrapper {
			max-width: unset;
			width: 100%;
		}
		.header-description-wrapper {
			align-items: center;
			text-align: left;
		}
	}
`;
export const TopicsWrapper = styled.div`
	position: sticky;
	top: 10rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	.topics-label {
		font-size: 14px;
	}
	.topic-text {
		cursor: pointer;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		gap: 0.5rem;
	}
`;
export const ScrollableTopicWrapper = styled.div`
	position: sticky;
	top: 10rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	.topic-button {
		border: none;
		background: transparent;
		box-shadow: none;
		text-align: left;
	}
	:hover {
		mask-image: none;
		-webkit-mask-image: none;
	}
	${(props) =>
		props.topicsCount > 7 &&
		!props.removeGradient &&
		`-webkit-mask-image: -webkit-gradient(
    linear,
    left 20%,
    left bottom,
    from(black),
    to(rgba(0, 0, 0, 0))
  );
  mask-image: -webkit-gradient(
    linear,
    left 20%,
    left bottom,
    from(black),
    to(rgba(0, 0, 0, 0))
  );;`}

	.selected-topic {
		animation: fadeInTopic 1s;
		@keyframes fadeInTopic {
			0% {
				opacity: 0.5;
				transform: translateX(-8px);
			}

			100% {
				opacity: 1;
				transform: translateX(0);
			}
		}
	}
`;

export const CurriculumTopics = styled.div`
	&.show {
		display: flex;
		flex-direction: column;
		gap: 1.5rem;
		animation: 0.5s ease 0s 1 normal none running fadeInContent;
		@keyframes fadeInContent {
			0% {
				transform: translateX(-8px);
				opacity: 0.5;
			}
			100% {
				transform: translateX(0);
				opacity: 1;
			}
		}
	}

	&.hide {
		display: none;
	}
`;
